import type { ModelInfo } from '@tcc/shared';

const PROVIDER_LABEL: Record<string, string> = {
	google: 'Google',
	openai: 'OpenAI',
	anthropic: 'Anthropic',
	mistral: 'Mistral',
	meta: 'Meta',
};

/** Optgroup label for a model, e.g. "Anthropic · AWS Bedrock · London". */
export function modelGroupLabel(m: ModelInfo): string {
	const provider = PROVIDER_LABEL[m.provider] ?? m.provider;
	return m.platform ? `${provider} · ${m.platform}` : provider;
}

/**
 * `<option>`s for a model `<select>`, grouped by provider/platform in catalog
 * order so long catalogs (e.g. Bedrock) stay scannable.
 */
export function ModelOptions({ models }: { models: ModelInfo[] }) {
	const groups = new Map<string, ModelInfo[]>();
	for (const m of models) {
		const label = modelGroupLabel(m);
		groups.set(label, [...(groups.get(label) ?? []), m]);
	}
	return (
		<>
			{[...groups].map(([label, ms]) => (
				<optgroup key={label} label={label}>
					{ms.map((m) => (
						<option key={m.modelId} value={m.modelId}>
							{m.displayName}
						</option>
					))}
				</optgroup>
			))}
		</>
	);
}
